import { render, staticRenderFns } from "./OrganizationInfoArea.vue?vue&type=template&id=1fd6ccb4&scoped=true&"
import script from "./OrganizationInfoArea.vue?vue&type=script&lang=js&"
export * from "./OrganizationInfoArea.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationInfoArea.vue?vue&type=style&index=0&id=1fd6ccb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd6ccb4",
  null
  
)

export default component.exports